
import { Vue, Component } from 'vue-property-decorator'
import { MutationTypes } from '@/store/mutations'

import { humanDate, filterFunc, getDisastersColor } from '@/lib/common'
import { DayData, DisasterDatum } from '@/lib/types'

@Component({
	name: 'CurrentEvent',
	components: {}
})
export default class TimeSelector extends Vue {
	readonly humanDate = humanDate

	get date2DisasterIndex() {
		return this.$tStore.state.date2DisasterIndex
	}

	get showRainfall() {
		return this.$tStore.state.showRainfall
	}

	get eventData() {
		return this.$tStore.state.selectedEvent
	}

	get selectedFeatureIndex() {
		return this.$tStore.state.selectedFeatureIndex
	}

	get eventDays() {
		if (!this.eventData) {
			return []
		}
		interface DayWithDisasters extends DayData {
			hasDisasters: boolean
			disasterColor?: string
			majorDisaster?: boolean
		}
		const days: DayWithDisasters[] = []
		let fi = 0
		// @ts-ignore
		for (let f of this.eventData?.features) {
			let hasDisasters = false
			let majorDisaster = false
			let disasters: DisasterDatum[] = []
			if (
				this.$tStore.state.disasterData !== null &&
				this.$tStore.state.date2DisasterIndex.has(f.properties?.date.getTime())
			) {
				const disasterIndices = this.$tStore.state.date2DisasterIndex.get(
					f.properties?.date.getTime()
				)
				// @ts-ignore
				disasters = disasterIndices
					// @ts-ignore
					.map(i => this.$tStore.state.disasterData[i])
					.filter(d => filterFunc(d, this.$tStore.state.disasterFilter))
				hasDisasters = disasters.length > 0,
				majorDisaster = disasters.some(d => d.major)
			}
			let disasterColor = ''
			if(hasDisasters) {
				disasterColor = getDisastersColor(disasters)
			}
			days.push({
				date: f.properties?.date,
				color: this.$tStore.state.color,
				cloudBlobIndex: {
					fcIndex: this.$tStore.state.selectedEventIndex,
					fIndex: fi
				},
				hasDisasters,
				majorDisaster,
				disasterColor
			})
			fi++
		}
		return days
	}

	selectBlob(day: DayData) {
		if (!day.cloudBlobIndex) return
		this.$store.commit(MutationTypes.SET_SELECTED_FEATURE, {
			fcIndex: day.cloudBlobIndex.fcIndex,
			fIndex: day.cloudBlobIndex.fIndex,
			color: day.color
		})
	}

	get playing() {
		return this.$tStore.state.playing
	}

	set playing(value) {
		this.$tStore.commit(MutationTypes.SET_PLAYING, value)
	}

	playEvent() {
		const animStep = 500
		for (let i = 0; i < this.eventDays.length; i++) {
			this.playing = true
			setTimeout(() => {
				this.$store.commit(MutationTypes.SET_SELECTED_FEATURE, {
					fcIndex: this.$tStore.state.selectedEventIndex,
					fIndex: i
				})
			}, i * animStep)
			setTimeout(() => {
				this.$store.commit(MutationTypes.SET_SELECTED_FEATURE, {
					fcIndex: this.$tStore.state.selectedEventIndex,
					fIndex: 0
				})
				this.playing = false
			}, this.eventDays.length * animStep + 750)
		}
	}
}
